module.exports = __webpack_public_path__ + "static/img/lv.637e5c1a.png";